import React from "react"
import { useParams, useSearchParams } from "react-router-dom"
import { useAppCtx, appStore } from "lib/state"
import { queryTools } from "lib/utils"
import { TemplateSetup } from "."

export default function PreviewWrapper(){

  const { tmplid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams();
    
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { update } = AppStore
  
  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })

  return (
    <div className="w-full flex justify-start items-start *:text-gray-900 relative">
      <TemplateSetup />
    </div>
  )
}